export default class Router {

  constructor(controllers) {
    this.controllers = controllers

    this.root = '/wp-content/themes/la_mongolfiere'

    this.loader()

    const start = () => {
      //this.controllers.popin.init()
      if (document.querySelector('#home')) this.controllers.home.init()
      if (document.querySelector('#planning')) this.controllers.planning.init()
      if (document.querySelector('#infos')) this.controllers.infos.init()
      if (document.querySelector('#sport')) this.controllers.sport.init()
      if (document.querySelector('#coach')) this.controllers.coach.init()
      if (document.querySelector('#restaurant')) this.controllers.restaurant.init()
      if (document.querySelector('#event')) this.controllers.event.init()
      if (document.querySelector('#single-event')) this.controllers.singleEvent.init()
      if (document.querySelector('#account')) this.controllers.account.init()
      if (document.querySelector('#single-offers')) this.controllers.singleOffers.init()
      if (document.querySelector('#single-club')) this.controllers.singleClub.init()
      if (document.querySelector('#avantage')) this.controllers.avantage.init()
      this.controllers.header.init()
    }

    window.addEventListener('load', () => {
      this.firstLoaderIn()
      start()
    })

  }

  firstLoaderIn() {
    const $loaderWraps = document.querySelectorAll('.loader__wrap')
    const $loaderWrapFinal = document.querySelector('.loader__wrap-final')
    const $loaderText = document.querySelector('.loader__text')

    // Timeline In
    const timelineIn = new TimelineMax({ paused: true })
    timelineIn
      .to($loaderText, .25,
        { opacity: '0', ease: Circ.easeIn },
      )
      .to('.loader-initial', 0.5,
        { y: '-100%', ease: Circ.easeOut },
      )
      .to($loaderText, 0,
        { display: 'none' },
      )

    // First loader
    const timelineLoaderIn = new TimelineMax({ paused: true })
    timelineLoaderIn
      .to('.loader-initial', 0,
        { y: '-100%' },
        'start'
      )
      .to($loaderText, 0,
        { display: 'flex'},
        'start'
      )
      .staggerFromTo($loaderWraps, .5,
        { y: '0%', ease: Circ.easeIn },
        { y: '-200%' },
        .15,
        'loader'
      )
      .fromTo($loaderWrapFinal, .25,
        { y: '0%', ease: Circ.easeIn },
        { y: '-200%' },
        'loader+=.6'
      )
      .to($loaderText, .25,
        { opacity: '0', ease: Circ.easeIn },
        'loader+=0.7'
      )
      .to('.loader', 0,
        { display: 'none'},
      )


    if (sessionStorage.getItem('init')) {
      timelineIn.play()
    } else {
      timelineLoaderIn.play()
      sessionStorage.setItem('init', true)
    }

  }

  loader() {
    const $links = [...document.querySelectorAll('a')].filter(link => {
      const href = link.getAttribute('href');
      return href && !href.startsWith('#');
    });
    const $loaderWraps = document.querySelectorAll('.loader__wrap')
    const $loaderWrapFinal = document.querySelector('.loader__wrap-final')
    const $loaderText = document.querySelector('.loader__text')

    let location = ''
    let name = ''

    const updateLocation = () => {
      window.location.replace(location)
    }

    const timelineOut = new TimelineMax({ paused: true, onComplete: updateLocation })
    timelineOut
      .to($loaderText, 0,
        { display: 'flex', opacity: 1 },
        'start'
      )
      .to('.loader', 0,
        { display: 'block'},
        'start'
      )
      .staggerFromTo($loaderWraps, .5,
        { y: '0%', ease: Circ.easeIn },
        { y: '-200%' },
        .15,
        'loader'
      )
      .fromTo($loaderWrapFinal, .25,
        { y: '0%', ease: Circ.easeIn },
        { y: '-100%' },
        'loader+=.6'
      )

    for (const $link of $links) {
      if ($link.getAttribute('target') !== '_blank') {
        $link.addEventListener('click', (event) => {
          event.preventDefault()

          const titleTransition = $link.getAttribute('data-title-transition')

          location = $link.href
          name = $link.innerText

          if($link.getAttribute('href') === '#') return

          if (titleTransition) {
            $loaderText.innerHTML = titleTransition
          } else if (name && name !== 'accueil') {
            if ($link.parentNode.classList.contains('menu-item')){
              $loaderText.innerHTML = name
            } else {
              $loaderText.innerHTML = ''
            }
          } else {
            if ($loaderText.querySelector('p')) {
              $loaderText.querySelector('p').style.display = 'none'
            }
            $loaderText.querySelector('.loader__logo').style.display = 'block'
          }
          timelineOut.play()
          window.location=location;
          // this.ajax(location)
        })
      }
    }
  }

  ajax(route) {
    this.isRequesting = true
    const url = route
    let success = false
    const http = new XMLHttpRequest()
    http.onreadystatechange = () => {
      if (http.readyState == 4 && http.status == 200) {
        if (http.readyState == 4) {
          this.replaceDOM()
          this.controllers.header.init()
          //this.controllers.popin.init()
          if (document.querySelector('#home')) this.controllers.home.init()
          if (document.querySelector('#planning')) this.controllers.planning.init()
          if (document.querySelector('#infos')) this.controllers.infos.init()
          if (document.querySelector('#sport')) this.controllers.sport.init()
          if (document.querySelector('#coach')) this.controllers.coach.init()
          if (document.querySelector('#restaurant')) this.controllers.restaurant.init()
          if (document.querySelector('#event')) this.controllers.event.init()
          if (document.querySelector('#single-club')) this.controllers.singleClub.init()
          if (document.querySelector('#avantage')) this.controllers.avantage.init()
          if (document.querySelector('#single-event')) this.controllers.singleEvent.init()
          if (document.querySelector('#account')) this.controllers.account.init()
          if (document.querySelector('#single-offers')) this.controllers.singleOffers.init()
        }
      }
    }
    http.open('GET', url, true)
    http.send()
  }

  replaceDOM(route) {
    const $view = document.querySelector('.view')
    $view.innerHTML = ''
  }
}